import {Component, inject, OnInit, signal, viewChild, ChangeDetectionStrategy} from '@angular/core';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { Observable, of } from 'rxjs';
import { filter, map, withLatestFrom } from 'rxjs/operators';

import { AuthService } from '@fry/lib/auth';
import { MenuIcon } from '@fry/components/common/buttons/buttons.list.component';
import { EASButtonAction, EASLinkAction } from '@fry/components/common/buttons';
import { AsyncPipe } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MenuItem } from '@fry/lib/menu';
import { ClusterOrganisation, ClusterService } from '@fry-it/risr-core';
import { OidcService } from '@fry-it/risr-core';
import { MatButton } from '@angular/material/button';
import { FryCommonModule } from '@fry/components/common';

@Component({
    selector: 'app-portal-menu',
    templateUrl: './portal-menu.component.html',
    styleUrls: ['./portal-menu.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
      RouterLink,
      MatSidenavModule,
      AsyncPipe,
      MatToolbarModule,
      MatButton,
      FryCommonModule
  ]
})
export class PortalMenuComponent implements OnInit {

  private drawer = viewChild(MatSidenav);

  menu = signal<MenuItem[]>([]);

  private router = inject(Router);
  private breakpointObserver = inject(BreakpointObserver);
  private cluster = inject(ClusterService);
  private oidc = inject(OidcService);

  currentUser = this.oidc.currentUser;
  apiInfo = this.oidc.apiInfo;

  $org = signal<ClusterOrganisation | null>(null);

  // Export MenuIcons enum to the template
  public MenuIcons = MenuIcon;

  languagesButtonsButtons: (EASButtonAction | EASLinkAction)[] = [];
  avatarButtons: (EASButtonAction | EASLinkAction)[] = [
    {
      type: 'button',
      label: $localize `Logout`,
      condition: () => {
        return of(true);
      },
      click: () => this.auth.startLogout(),

    }
  ];

  constructor(
    private auth: AuthService,
  ) {
    const otherLanguages = this.cluster.getOtherLanguages();
    otherLanguages.forEach((lang) => {
      this.languagesButtonsButtons.push({
        type: 'button',
        label: lang.language_name,
        condition: () => {
          return of(true);
        },
        click: () => {
          window.location.href = `${lang.base_href}${this.router.url}`;
        }
      });
    });

    this.router.events.pipe(
      withLatestFrom(this.isHandset$),
      filter(([a, b]) => b && a instanceof NavigationEnd)
    ).subscribe(_ => this.drawer()?.close());

  }

  isHandset$: Observable<boolean> = this.breakpointObserver.observe([Breakpoints.Small, Breakpoints.HandsetPortrait])
    .pipe(
      map(result => result.matches)
  );

  ngOnInit() {
    console.log('Menu: Initialising menu');
    try {
      this.$org.set(this.cluster.getCurrentOrganisation());
    } catch (e) {
      console.error(e);
    }
  }

  login() {
    this.auth.startLogin();
  }

}
